@if (progressService.isLoading()) {
    <du-config-detail-skeleton></du-config-detail-skeleton>
} @else {
    <du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.APP_SETTINGS, setting?.applicationName]}">
        <detail-header>
            @if (logoUrl && logoUrl.length > 0) {
                <img [ngSrc]="logoUrl" alt="{{ setting?.applicationName }} logo" width="64" height="64"
                     priority>
            }

            <div>
                <h1 class="detail-header-title">{{ setting?.applicationName }}</h1>
                <p class="detail-header-subtitle">{{ "#" + setting?.id }}</p>
            </div>
        </detail-header>
        @if (isAuthorized) {
            <detail-header-action>
                @if (!isActive && isEditable) {
                    <p-button severity="secondary" (click)="reactivate()">
                        <i class="pi pi-history"></i>
                        {{ "appSettings.reactivate" | translate | uppercase }}
                    </p-button>
                }
                <p-button (click)="cloneConfiguration()">
                    <i class="pi pi-copy"></i>
                    {{ "appSettings.clone" | translate | uppercase }}
                </p-button>
            </detail-header-action>
        }
        <detail-body>
            <p-card class="app-settings-detail-card">
                    @if (isEditable && setting) {
                        @if (isActive) {
                        <form class="form-container">
                            <div class="field">
                                <label>{{ 'appSettings.application' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.applicationName" name="applicationName">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.identification' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.identification" name="identification">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.tenantName' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.tenantName" name="tenantName">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.participantId' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.participantId" name="participantId">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.participantPartnerId' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.participantPartnerId" name="participantPartnerId">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.relationType' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.relationType" name="relationType">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.applicationType' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.applicationType" name="applicationType">
                            </div>
                            <div class="active-container">
                                <p-toggleswitch [(ngModel)]="setting.active" name="active" inputId="active-toggle"/>
                                <label for="active-toggle">{{ 'appSettings.active' | translate }}</label>
                            </div>
                        </form>
                        } @else {
                            <div class="metadata-grid">
                                <div class="metadata-item">
                                    <span class="metadata-label">{{ 'appSettings.tenantName' | translate }}</span>
                                    <span class="metadata-value">{{ setting.tenantName }}</span>
                                </div>
                                <div class="metadata-item">
                                    <span class="metadata-label">{{ 'appSettings.identification' | translate }}</span>
                                    <span class="metadata-value">{{ setting.identification }}</span>
                                </div>
                                <div class="metadata-item">
                                    <span class="metadata-label">{{ 'appSettings.status' | translate }}</span>
                                    <span class="metadata-value">
                                <i class="pi" [class.pi-check-circle]="setting.active" [class.active-icon]="setting.active"
                                   [class.pi-times-circle]="!setting.active" [class.inactive-icon]="!setting.active"></i>
                                        {{ (setting.active ? 'appSettings.active' : 'appSettings.inactive') | translate }}
                            </span>
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="metadata-grid">
                            <div class="metadata-item">
                                <span class="metadata-label">{{ 'appSettings.tenantName' | translate }}</span>
                                <span class="metadata-value">{{ setting?.tenantName }}</span>
                            </div>
                            <div class="metadata-item">
                                <span class="metadata-label">{{ 'appSettings.identification' | translate }}</span>
                                <span class="metadata-value">{{ setting?.identification }}</span>
                            </div>
                            <div class="metadata-item">
                                <span class="metadata-label">{{ 'appSettings.status' | translate }}</span>
                                <span class="metadata-value">
                                <i class="pi" [class.pi-check-circle]="setting?.active" [class.active-icon]="setting?.active"
                                   [class.pi-times-circle]="!setting?.active" [class.inactive-icon]="!setting?.active"></i>
                                    {{ (setting?.active ? 'appSettings.active' : 'appSettings.inactive') | translate }}
                            </span>
                            </div>
                        </div>
                    }

                    @if (reactivations.length > 0) {
                        <p-panel class="reactivation-panel" [toggleable]="true" [collapsed]="true">
                            <ng-template #header>
                                <div class="reactivation-panel-title">
                                    <i class="pi pi-history"></i>
                                    {{ 'appSettings.reactivations' | translate }}
                                </div>
                            </ng-template>
                            <p-table [value]="dataSource" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[3, 5, 10]"
                                     sortMode="single" [sortField]="'id'" [sortOrder]="-1" class="reactivation-table">
                                <ng-template #header>
                                    <tr>
                                        <th pSortableColumn="id">ID<p-sortIcon field="id"/></th>
                                        <th pSortableColumn="reason">{{ 'appSettings.reason' | translate }}<p-sortIcon field="reason"/></th>
                                        <th pSortableColumn="userName">{{ 'appSettings.userName' | translate }}<p-sortIcon field="userName"/></th>
                                        <th pSortableColumn="timestamp">{{ 'appSettings.timestamp' | translate }}<p-sortIcon field="timestamp"/></th>
                                    </tr>
                                </ng-template>
                                <ng-template #body let-reactivation>
                                    <tr>
                                        <td>#{{ reactivation.id }}</td>
                                        <td>{{ reactivation.reason }}</td>
                                        <td>{{ reactivation.userName }}</td>
                                        <td>{{ reactivation.timestamp | date: 'dd.MM.yyyy HH:mm' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-panel>
                    }

                    @if (!isComparisonActive) {
                        <div class="editor-container">
                            <div class="editor-header">
                                <i class="pi pi-code"></i>
                                <span>{{ 'appSettings.jsonSettings' | translate }}</span>
                                <div class="editor-header-actions">
                                    @if (this.allSettings.length > 0) {
                                        <div class="version-selector">
                                            <p-select [ngModel]="id" (ngModelChange)="appSettingsDetail($event)"
                                                          [options]="versionOptions" optionLabel="label" optionValue="data" placeholder="ID"/>
                                        </div>
                                        <div class="compare-selector">
                                            <p-select [(ngModel)]="selectedSecondSettingId" (ngModelChange)="secondVersion($event)"
                                                          [options]="compareOptions" optionLabel="label" optionValue="data"/>
                                        </div>
                                    }
                                    <div class="compare-selector">
                                        <p-select [(ngModel)]="selectedRevision" (ngModelChange)="onRevisionSelected($event)"
                                                      [options]="revisionOptions" optionLabel="label" optionValue="data" [placeholder]="'appSettings.compareRev' | translate"/>
                                    </div>
                                    @if (this.allSettings.length <= 0) {
                                        <span>#{{ id }}</span>
                                    }
                                </div>
                            </div>
                            <div class="editor">
                                <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="code"></ngx-monaco-editor>
                            </div>
                        </div>
                    } @else {
                        <div class="editor-container">
                            @if (!isRevisionComparing) {
                                <div class="editor-header">
                                    <i class="pi pi-code"></i>
                                    <div class="version-label">
                                        {{ 'appSettings.identification' | translate }}: #{{ selectedFirstSetting?.id }}
                                    </div>
                                    <div class="version-label form">
                                        <div class="compare-selector">
                                            <p-select [(ngModel)]="selectedSecondSettingId" (ngModelChange)="secondVersion($event)"
                                                          [options]="compareOptionsStop" optionLabel="label" optionValue="data" [placeholder]="'appSettings.compareId' | translate"/>
                                        </div>
                                    </div>
                                    <p-button [rounded]="true" [text]="true" severity="secondary" (click)="stopComparing()"><i class="pi pi-times"></i></p-button>
                                </div>
                            } @else {
                                <div class="editor-header">
                                    <i class="pi pi-code"></i>
                                    <div class="version-label">
                                        {{ 'appSettings.identification' | translate }}: #{{ selectedFirstSetting?.id }}
                                    </div>
                                    <div class="version-label form">
                                        <div class="compare-selector">
                                            <p-select [(ngModel)]="selectedRevision" (ngModelChange)="onRevisionSelected($event)"
                                                          [options]="revisionOptionsStop" optionLabel="label" optionValue="data" [placeholder]="'appSettings.compareRev' | translate"/>
                                        </div>
                                    </div>
                                    <p-button [rounded]="true" [text]="true" severity="secondary" (click)="stopComparing()"><i class="pi pi-times"></i></p-button>
                                </div>
                            }
                            <div class="editor">
                                <ngx-monaco-diff-editor
                                        [options]="options"
                                        [originalModel]="originalModel"
                                        [modifiedModel]="modifiedModel">
                                </ngx-monaco-diff-editor>
                            </div>
                        </div>
                    }
                    <div class="editor-actions">
                        @if (isEditable) {
                            @if (isComparisonActive) {
                                <p-button severity="secondary" (click)="replaceOriginalCode()">
                                    <i class="pi pi-sync"></i>
                                    {{ 'button.replace' | translate | uppercase }}
                                </p-button>
                            }
                            <p-button severity="secondary" (click)="resetAppSettings()">
                                <i class="pi pi-refresh"></i>
                                {{ 'button.reset' | translate | uppercase }}
                            </p-button>
                            <p-button (click)="saveAppSettings()">
                                <i class="pi pi-save"></i>
                                {{ 'button.save' | translate | uppercase }}
                            </p-button>
                        }
                    </div>
            </p-card>
        </detail-body>
    </du-config-detail>
}
